import React, { useEffect, useState, useRef } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRInput from '../../assets/dsgov/js/components/input';
import '../../assets/dsgov/css/components/input.css';
import './Input.css';
import FieldFeedback from './FieldFeedback';

const Input = (_props) => {
  const [componentId] = useState(`list${componentIdGenerator()}`);
  const props = parseProps(_props);
  const inputRef = useRef(null);

  useEffect(() => {
    new BRInput(
      'br-input',
      window.document.querySelector(`.${componentId}`),
    );
  });

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('focusout', () => {
        if (!inputRef.current) return;
        if (props.min && inputRef.current.value < props.min) {
          inputRef.current.value = props.min;
          if (props.onChange) props.onChange({ target: { value: props.min } });
        } else if (props.max && inputRef.current.value > props.max) {
          inputRef.current.value = props.max;
          if (props.onChange) props.onChange({ target: { value: props.max } });
        }
      });
    }
  }, [inputRef]);

  let classes = `br-input ${componentId}`;
  if (props.classes) classes = `${classes} ${props.classes}`;

  let type = 'text';
  if ('password' in props) type = 'password';
  else if ('number' in props) type = 'number';
  else if ('file' in props) type = 'file';
  const id = 'id' in props ? props.id : componentId;

  const attr = {
    filter: props.filter,
    valid: props.valid,
    invalid: props.invalid,
    small: props.small,
    title: props.title,
  };

  const attrInput = {
    step: props.step,
    disabled: props.disabled,
  };

  let feedback = null;
  if (!props.disableMessageValidation) {
    if ('feedback_message' in props) {
      feedback = <FieldFeedback {...props} />;
    }
    if ('feedback' in props) {
      feedback = props.feedback;
    }
  }

  const label = props.label ? (
    <div style={{ minWidth: props.labelWidth }}>
      <label htmlFor={id}>{props.label}</label>
    </div>
  ) : null;

  return (
    <div className={classes} {...attr}>
      <div className={props.inline ? 'inline' : null}>
        {label}
        <input
          ref={inputRef}
          min={props.min || '0'}
          max={props.max || null}
          {...attrInput}
          style={{ width: props.width }}
          type={type}
          value={props.value}
          id={id}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onBlur={props.onBlur}
          size={props.size || null}
        />
        {props.button}
      </div>
      {feedback}
    </div>
  );
};

export default Input;
